import { render } from 'preact';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Utilities
import { getPackageData } from './utilities/api/package';
import { createFlowEvent } from './utilities/common';
import Api from './utilities/api/api';

// Actions
import { appLoading, appInitial } from './actions/App';
import { generateStore } from './utilities/configureStore';

import App from './containers/App';
import './wrapper';

import main from './assets/styles/main.scss?inline'

import './assets/styles/Fina/global_fina.scss'

// Anchor
import './anchor-setup';

export default class Flow extends HTMLElement {
  static get observedAttributes() {
    return ['path', 'api', 'token', 'tealiumEnv'];
  }

  constructor() {
    super();
    this.path = '';
    this.api = '';
    this.token = '';
    this.tealiumEnv = '';
    const { store, persistor } = generateStore();
    this.store = store;
    this.persistor = persistor;
  }

  beforeLift() {
    const initialize = (event) => {
      this.store.dispatch(appInitial(event.detail || {}));
      // Get package data.
      this.store
        .dispatch(getPackageData())
        .then(() => this.store.dispatch(appLoading(false)));
      window.removeEventListener('flow-notify-default', initialize);
    };

    window.addEventListener('flow-notify-default', initialize);
  }

  createFlow() {
    if (this.api) {
      Api.API_HOST = this.api;
    }

    render(
      <Provider store={this.store}>
        <PersistGate
          onBeforeLift={this.beforeLift()}
          persistor={this.persistor}
        >
          <App />
        </PersistGate>
      </Provider>,
      this.mountPoint
    );

    createFlowEvent('loaded');
    window.dispatchEvent(
      new CustomEvent('flow-notify-default', {
        detail: {
          app: {
            pathname: this.path,
          },
          userData: {
            token: this.token,
          },
        },
      })
    );
  }

  connectedCallback() {
    const style = document.createElement('style');
    style.innerHTML = main;
    this.appendChild(style);
    this.path = this.getAttribute('path');
    this.api = this.getAttribute('api') || this.api;
    this.token = this.getAttribute('token');
    this.tealiumEnv = this.getAttribute('tealiumEnv');
    this.mountPoint = document.createElement('div');
    this.appendChild(this.mountPoint);
    this.createFlow();
  }

  attributeChangedCallback(attribute, oldValue, newValue) {
    if (attribute === 'path') {
      this.path = newValue;
    } else if (attribute === 'api') {
      this.api = newValue;
    } else if (attribute === 'token') {
      this.token = newValue;
    }
  }
}

const widgetTag = import.meta.env.VITE_WIDGET_TAG;
if (!window.customElements.get(widgetTag)) {
  window.customElements.define(widgetTag, Flow);
}
